export default "__VITE_ASSET__DQx2ydN6__"